
// doesn't rely on jquery except for $.extend
// but doesn't matter since we're waiting for jquery
// document to load first in app.js
import $ from 'jquery';
import Cookies from 'js-cookie';

import getScrollbarWidth from './util/getScrollbarWidth';
import debounce from './util/debounce';
import globals from './global/globals';
import logger from './logger';


export default function (options) {
    var o = $.extend({
        // defaults imported from globals are in vw
        gutter: globals.grid.gutter,
        outergutter: globals.grid.outergutter,

        devMode: true
    }, options);


    var ele = {
        presetCustomProperties: document.getElementById('css-custom-properties')
    };


    var intrn = {
        name: 'CSSCustomProperties',
        docStyle: document.documentElement.style,

        state: 'default', // can be 'default' or 'overridden'

        winOuterWidth: null,
        winInnerWidth: null,
        scrollbarWidth: getScrollbarWidth(),
        isPhone: null
    };


    var fn = {
        init: function () {
            fn.setOrUnsetProperties();
            window.addEventListener('resize', debounce(handlers.resize, 100));
        },

        setOrUnsetProperties: function () {
            var cookiedWinWidth, scrollbar, isSameAsCookie;

            // need to do a bit more cross-browser testing, but the
            // method below to find out the inner width does NOT
            // acutally use the measured scrollbar width, so definitions
            // of the scrollbar width can prob be taken out
            intrn.winOuterWidth = window.outerWidth;
            intrn.winInnerWidth = document.documentElement.clientWidth;
            intrn.isPhone = (intrn.winOuterWidth <= globals.breakpoints.phoneMax);

            cookiedWinWidth = Cookies.get('CSSPropWinWidth');
            scrollbar = (intrn.scrollbarWidth && intrn.scrollbarWidth > 0);
            isSameAsCookie = (cookiedWinWidth === intrn.winInnerWidth.toString());

            fn.console('scrollbar width: *' + intrn.scrollbarWidth + 'px*');
            fn.console(['inner viewport width is ' + (isSameAsCookie ? 'the same as' : 'different from') + ' cookied value']);

            // don't do anythign if there's a scrollbar and the cookied
            // viewport widht is the same (but still allow to proceed
            // if there's a cookied width but no scrollbars so that we
            // can remove any saved cookies if they exist)
            if (scrollbar && isSameAsCookie) {
                fn.console('not setting or unsetting anything');
            } else if (scrollbar || intrn.isPhone) {
                fn.setProperties();
            } else {
                fn.unsetProperties();
            }
        },
        setProperties: function () {
            var winInnerWidth, isPhone, gutter, outergutter, col, root;

            winInnerWidth = intrn.winInnerWidth;
            isPhone = intrn.isPhone;

            // if it's a phone, gutter stays constant at the pixel
            // value of what the gutter is at the max phone width
            if (isPhone) {
                gutter = o.gutter * globals.breakpoints.phoneMax;
                outergutter = o.outergutter * globals.breakpoints.phoneMax;
            } else {
                gutter = o.gutter * winInnerWidth;
                outergutter = o.outergutter * winInnerWidth;
            }

            // round down gutters
            gutter = Math.floor(gutter);
            outergutter = Math.floor(outergutter);

            // define column width (not including gutter per column)
            // and then round down to two decimal places
            col = (winInnerWidth - (11 * gutter) - (2 * outergutter)) / 12;
            col = Math.floor(col * 100) / 100;

            root = intrn.docStyle;
            root.setProperty('--win-width', winInnerWidth + 'px');
            root.setProperty('--col-gutter', gutter + 'px');
            root.setProperty('--col-outergutter', outergutter + 'px');
            root.setProperty('--col-width', col + 'px');

            // save in cookies
            Cookies.set('CSSPropWinWidth', winInnerWidth);
            Cookies.set('CSSPropGutter', gutter);
            Cookies.set('CSSPropOutergutter', outergutter);
            Cookies.set('CSSPropColWidth', col);

            if (isPhone) {
                var rowSpacePhone = gutter * 2;
                root.setProperty('--row-space', rowSpacePhone + 'px');
                Cookies.set('CSSPropRowSpace', rowSpacePhone);
            } else {
                root.removeProperty('--row-space');
                Cookies.remove('CSSPropRowSpace');
            }

            intrn.state = 'overridden';

            fn.console('*css custom properties overridden*');
            fn.console([
                'outer gutters: *' + outergutter + 'px*',
                'gutter: *' + gutter + 'px*',
                'column: *' + col + 'px*'
            ]);
            fn.console([
                'inner viewport: *' + winInnerWidth + 'px*',
                'outer window: *' + intrn.winOuterWidth + 'px*'
            ]);
        },
        unsetProperties: function () {
            var root;

            root = intrn.docStyle;
            root.removeProperty('--win-width');
            root.removeProperty('--col-gutter');
            root.removeProperty('--col-outergutter');
            root.removeProperty('--col-width');
            root.removeProperty('--row-space');

            // delete cookies
            Cookies.remove('CSSPropWinWidth');
            Cookies.remove('CSSPropGutter');
            Cookies.remove('CSSPropOutergutter');
            Cookies.remove('CSSPropColWidth');
            Cookies.remove('CSSPropRowSpace');

            // remove preloaded style overrides
            if (ele.presetCustomProperties) {
                ele.presetCustomProperties.remove();
                ele.presetCustomProperties = null;
            }

            intrn.state = 'default';

            fn.console('*css custom properties unset*');
        },

        console: function (msgs) {
            logger(msgs, {
                enabled: o.devMode,
                prefix: intrn.name + '.js',
                prefixColor: 'cyan'
            });
        }


    };


    var handlers = {
        resize: function (entries) {
            fn.setOrUnsetProperties();
        }
    };


    fn.init();
}
